import { useEffect, useState } from 'react'
import { db } from 'firebase/index'
import { CouponType } from 'types/coupon'

const fetchCouponCodes = (): Promise<string[]> => {
  return db
    .collection('coupons')
    .get()
    .then((snapshots) => {
      const codes: string[] = []
      snapshots.forEach((snapshot) => {
        const data = snapshot.data() as CouponType
        codes.push(data.code)
      })
      return codes
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}

const useQueryCouponCodes = (): string[] => {
  const [couponCodes, setCouponCodes] = useState<string[]>([])
  useEffect(() => {
    ;(async () => {
      const _couponCodes = await fetchCouponCodes()
      setCouponCodes([..._couponCodes])
    })()
  }, [])
  return couponCodes
}

export default useQueryCouponCodes
